// @flow
import { getSocket, getSocketIfExist } from '../../utils/getSocket';
import { updateDownAudio } from '../../utils/ws-v1';

export const updateSpeakerListened = (speaker: Object) => {
  updateDownAudio(getSocketIfExist(), speaker);
  const speakerIdentified = speaker.trackId || speaker.avaId;
  return {
    type: 'UPDATE_SPEAKER_LISTENED',
    speaker: speakerIdentified,
  };
};
